<template>
    <div class="BulkFeedbackComponent dataTables">

        <p v-show="isData">{{ lang.infotext_1 }}:</p>
        
        <div :id="id"></div>
        <br>
        
        <!-- <LoaderComponent  v-show="!isData"></LoaderComponent> -->

    </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'

import $ from 'jquery';
import dt from 'datatables.net-bs4';


export default {
    name: "BulkFeedbackComponent",
    props: {
        lang: Object,
        reloadTable: Boolean,
        data: Object
    },
    components: {

        LoaderComponent
    },
    data() {
        return {
            name: "BulkFeedbackComponent",
            mainTable: "",
            items: [],
            id: "place_BulkFeedbackComponent",
            searchTableInput: ""
        }
    },
    computed: {
        ...mapGetters({

            appConf: 'appConf'

        }),
        
        isData() {
            return this.items.length != 0
        },
        
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        }
    },
    created() {
        

    },
    mounted() {
        
        this.prepareData();
        
    },
    watch: {

    },
    updated() {


    },
    methods: {
        prepareData() {

            this.items = [];
            let data = this.data.data;
            
            for (let i = 0, lei = data.length; i < lei; i++) {


                const obj = {}
                if (this.$store.getters.sectionPrefix == "pm") {
                    obj.id = data[i].partId;
                    obj.number = data[i].partNumber;
                    obj.status = data[i].success;
                    obj.message = data[i].message;
                }
                if (this.$store.getters.sectionPrefix == "lm") {
                    obj.id = data[i].libraryId;
                    obj.number = data[i].libraryNumber;
                    obj.status = data[i].success;
                    obj.message = data[i].message;
                }
                if (this.$store.getters.sectionPrefix == "projm") {
                    obj.id = data[i].projectId;
                    obj.number = data[i].projectNumber;
                    obj.status = data[i].success;
                    obj.message = data[i].message;
                }

                this.items.push(obj)
            }

            if (this.items.length > 0) {
                this.buildTable();
            }
            

        },

        buildTable() {



            let tableplace = document.getElementById(this.id);
            
            if (tableplace == null) {
                return
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            let table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            let tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            let thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            let _vue = this;

            let name = "";
            if (this.$store.getters.sectionPrefix == "pm") {
                name = this.lang.table_header_PartNumber
            }
            if (this.$store.getters.sectionPrefix == "lm") {
                name = this.lang.table_header_LibraryNumber
            }
            if (this.$store.getters.sectionPrefix == "projm") {
                name = this.lang.table_header_ProjectNumber
            }

            let columns = [

                {
                    name: name,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Status,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Message,
                    alignInColumn: "left",

                },


            ]

            let cols = [

                { "data": "number" },
                { "data": "status" },
                { "data": "message" },

            ]


            let columnDefs = [];
            let len = columns.length;
            for (let i = 0; i < len; i++) {
                

                let classname = '_dt-body-' + columns[i].alignInColumn;

                const el = {
                    targets: i,
                    //width: widthCol,
                    className: classname,

                    render: function (data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }


                        if (meta.col == 0) {

                            return data;

                        }
                        if (meta.col == 1) {
                            
                            
                            let d = "";
                            if (row.status == false) {
                                d = "<b-badge class='badge badge-danger'>Error</b-badge> ";
                            } else {
                                d = "<b-badge class='badge badge-success'>Success</b-badge> ";
                            }
                            
                            

                            return d;
                        }
                        if (meta.col == 2) {


                            return data;
                        }



                    },


                }

                columnDefs.push(el);



                let th = document.createElement("th");
                tr.appendChild(th);
                let p = document.createElement("p");
                th.appendChild(p);

                let tx = document.createTextNode(columns[i].name)
                p.appendChild(tx);

            }


            const json = {};
            json.paging = true;
            json.info = true;
            json.dom = 'f<t>ip';
            json.data = this.items;
            json.myColumnFormats = columns;
            json.select = false;
            json.order = [[1, "asc"]];
            json.lengthMenu = [16];
            json.columns = cols;

            json.columnDefs = columnDefs;
            json.initComplete = function () {



            }

            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();

            }



            this.mainTable = $('#t_' + this.id).DataTable(json);

            this.mainTable.columns.adjust().draw();

            //hide first column in table
            //this.mainTable.column( 0 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm");



        }

    }


}
</script>
<style lang="scss">
// @import "./../../scss/_theme.scss";
// @import "./../../scss/_tables.scss";

@import "./../../scss/_custom.scss";


.BulkFeedbackComponent {
    table {
        font-size: 0.75rem;
        padding: 0px !important;
        width: 100% !important;
        margin-right: 10px;

    }

    table th {
        padding: 2px !important;
        min-width: 300px;
    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    table {
        .btn {
            padding: 0.15rem 0.5rem;
            margin: 2px;
        }
    }

    .badge{
        margin: 3px;
    }

    
}</style>



// WEBPACK FOOTER //
// src/components/shared/BulkFeedbackComponent.vue